import RequestEgr from './RequestEgrContainer.vue';

export { RequestEgr };



// WEBPACK FOOTER //
// ./src/modules/home/requestEgr/index.js